import Vue from 'vue'
import Router from 'vue-router'
import sidebar from '../utils/sidebar'
import { store } from '../store'

import Index from '@/components/HomePage/Index.vue'
import About from '@/components/HomePage/About.vue'
import Calendar from '@/components/HomePage/Calendar.vue'
import Director from '@/components/HomePage/Director.vue'
import NewsArticle from '@/components/HomePage/NewsArticle.vue'
import News from '@/components/HomePage/News.vue'
import Signup from '@/components/HomePage/Signup.vue'
import Login from '@/components/HomePage/Login.vue'

import AdminDashboard from '@/components/Admin/Dashboard.vue'
import AdminClassrooms from '@/components/Admin/Classrooms.vue'
import AdminClassroom from '@/components/Admin/Classroom.vue'
import AdminInstructor from '@/components/Admin/Instructor.vue'
import AdminStudents from '@/components/Admin/Students.vue'
import AdminCalendar from '@/components/Admin/Calendar.vue'
import AdminNews from '@/components/Admin/News.vue'

// import InstructorDashboard from '@/components/Instructor/Dashboard.vue'
import InstructorClassrooms from '@/components/Instructor/Classrooms.vue'
import InstructorClassroom from '@/components/Instructor/Classroom.vue'

import StudentClassrooms from '@/components/Student/Classrooms.vue'
import StudentClassroom from '@/components/Student/Classroom.vue'

import NotFound from '@/components/Misc/404.vue'

import HomeConfig from './homeconfig'
import AdminGuard from './adminguard'
import InstructorGuard from './instructorguard'
import StudentGuard from './studentguard'
import Logout from './logout'

Vue.use(Router)

export const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      beforeEnter: HomeConfig
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      beforeEnter: HomeConfig
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: Calendar,
      beforeEnter: HomeConfig
    },
    {
      path: '/director',
      name: 'Director',
      component: Director,
      beforeEnter: HomeConfig
    },
    {
      path: '/news',
      name: 'News',
      component: News,
      beforeEnter: HomeConfig
    },
    {
      path: '/news/:id',
      name: 'NewsArticle',
      component: NewsArticle,
      beforeEnter: HomeConfig
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      beforeEnter: HomeConfig
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: HomeConfig
    },
    // Admin Routes
    {
      path: '/admin',
      name: 'AdminDashboard',
      component: AdminDashboard,
      beforeEnter: AdminGuard
    },
    {
      path: '/admin/classroom',
      name: 'AdminClassrooms',
      component: AdminClassrooms,
      beforeEnter: AdminGuard
    },
    {
      path: '/admin/classroom/:id',
      name: 'AdminClassroom',
      component: AdminClassroom,
      beforeEnter: AdminGuard
    },
    {
      path: '/admin/instructors',
      name: 'AdminInstructor',
      component: AdminInstructor,
      beforeEnter: AdminGuard
    },
    {
      path: '/admin/students',
      name: 'AdminStudents',
      component: AdminStudents,
      beforeEnter: AdminGuard
    },
    {
      path: '/admin/calendar',
      name: 'AdminCalendar',
      component: AdminCalendar,
      beforeEnter: AdminGuard
    },
    {
      path: '/admin/news',
      name: 'AdminNews',
      component: AdminNews,
      beforeEnter: AdminGuard
    },
    {
      path: '/logout',
      name: 'Logout',
      beforeEnter: Logout
    },
    // Instructor Routes
    {
      path: '/instructor',
      name: 'InstructorClassrooms',
      component: InstructorClassrooms,
      beforeEnter: InstructorGuard
    },
    {
      path: '/instructor/classroom/:id',
      name: 'InstructorClassroom',
      component: InstructorClassroom,
      beforeEnter: InstructorGuard
    },
    // {
    //   path: '/instructor/classrooms',
    //   name: 'InstructorClassroom',
    //   component: InstructorClassroom,
    //   beforeEnter: InstructorGuard
    // },
    // Student Routes
    {
      path: '/student',
      name: 'StudentClassrooms',
      component: StudentClassrooms,
      beforeEnter: StudentGuard
    },
    {
      path: '/student/classroom/:id',
      name: 'StudentClassroom',
      component: StudentClassroom,
      beforeEnter: StudentGuard
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    },
  ],
  mode: 'history'
})


// WEBPACK FOOTER //
// ./src/router/index.js